import styled from 'styled-components';

const InnerSiteHeaderWrapper = styled.div`
   display: flex;
   height: ${({ theme }) => theme.sizes.siteHeaderHeight};
`;

export { InnerSiteHeaderWrapper };
